

export default {
  kategoriList: [],
  totalRecords: 0,
}
